export default __webpack_public_path__ + "static/media/translation-icon.c169e808.svg";